export default __webpack_public_path__ + "static/media/Image-1.4c8a3683.png";